import React from 'react'
import './App.css';
import reducer from './reducers';
import { createStore, applyMiddleware } from 'redux'
import { Provider } from 'react-redux';
import thunkMiddleware from 'redux-thunk';
import logger from 'redux-logger';
import LoadDatas from './pages/loadDatas/LoadDatas';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import { ModalProvider } from './components/general/modalContext';
import { GlobalProvider, useGlobalContext } from './components/general/globalContexte';
import {
  BrowserRouter as Router,
} from "react-router-dom";

const themeColor = createTheme({
  palette: {
    primary: {
      main: "#1976d2",
    },
    secondary: {
      main: "#388e3c",

    }
  },
    theme1: {
      bandeauMenu :{
        backgroundColor: "#fff!important",
        color: "#37A8AF!important",
      }
    }
});

const Reloadable = () => {
  const global = useGlobalContext();
  return (<ModalProvider>
    {global.reload > 0 && <LoadDatas reload={global.reload} className="main-theme" />}
  </ModalProvider>);
}

const App = () => {
  let middleware = null;
  if (process.env.NODE_ENV !== 'production') {
    middleware = applyMiddleware(thunkMiddleware, logger);
  } else {
    middleware = applyMiddleware(thunkMiddleware);
  }

  const store = createStore(reducer, middleware);
  return (
    <ThemeProvider theme={themeColor}>
      <Provider store={store}>
        <GlobalProvider>
          <Router>
            <Reloadable />
          </Router>
        </GlobalProvider>
      </Provider>
    </ThemeProvider>
  );
}

export default App;
